import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";

export default function Suppliers() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", country: "Türkiye", contact: "", email: "", phone: "" });

  const load = async () => setItems((await api.get("/suppliers")).data);
  useEffect(() => { load(); }, []);

  const create = async () => {
    await api.post("/suppliers", form);
    toast.success("Eklendi");
    setOpen(false);
    setForm({ name: "", country: "Türkiye", contact: "", email: "", phone: "" });
    load();
  };
  const del = async (id) => { if (!window.confirm("Silmek?")) return; await api.delete(`/suppliers/${id}`); load(); };

  return (
    <div className="space-y-6" data-testid="suppliers-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">Tedarik</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight mt-1">Tedarikçiler</h2>
        </div>
        <Dialog open={open} onOpenChange={setOpen}>
          <DialogTrigger asChild><Button data-testid="add-supplier-btn" className="bg-primary hover:bg-orange-600 text-white"><Plus size={16} className="mr-2" /> Tedarikçi Ekle</Button></DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>Yeni Tedarikçi</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <Input placeholder="Ad" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="supplier-name" />
              <Input placeholder="Ülke" value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} />
              <Input placeholder="İletişim Kişi" value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} />
              <Input placeholder="E-posta" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              <Input placeholder="Telefon" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} />
              <Button data-testid="save-supplier" onClick={create} className="w-full bg-primary hover:bg-orange-600 text-white">Kaydet</Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      <Card className="border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900 text-white text-left"><tr>{["Ad", "Ülke", "İletişim", "E-posta", "Telefon", ""].map(h => <th key={h} className="px-4 py-2 font-semibold">{h}</th>)}</tr></thead>
            <tbody>
              {items.map(s => (
                <tr key={s.id} className="border-t border-border hover:bg-slate-50">
                  <td className="px-4 py-2 font-semibold">{s.name}</td>
                  <td className="px-4 py-2">{s.country}</td>
                  <td className="px-4 py-2">{s.contact}</td>
                  <td className="px-4 py-2">{s.email}</td>
                  <td className="px-4 py-2">{s.phone}</td>
                  <td className="px-4 py-2 text-right"><Button size="sm" variant="ghost" onClick={() => del(s.id)}><Trash2 size={14} className="text-destructive" /></Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
